import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { ExtractService } from 'src/app/services/extract-service/extract.service';
import { MenuService } from 'src/app/services/menu-service/menu.service';
import { MessageService } from 'src/app/services/message-service/message.service';
import { ProfileService } from 'src/app/services/profile-service/profile.service';

@Component({
    selector: 'app-mm-menu-header',
    templateUrl: './mm-menu-header.component.html',
    styleUrls: ['./mm-menu-header.component.scss'],
})
export class MmMenuHeaderComponent implements OnInit {

    public menuInteracao: boolean = false;
    public menuLoja: boolean = false;
    public menuSuperacao: boolean = false;
    public menuInformacao: boolean = false;
    public menuPlanos: boolean = false;

    menuHeader: any = [];

    constructor(
        private router: Router,
        public modelLocator: ModelLocatorService,
        private messageServive: MessageService,
        private menuService: MenuService,
        private extractService: ExtractService,
        private profileService: ProfileService
    ) {
    }

    async ngOnInit() {
        this.menuHeader = [
            { key: 'interacao', label: 'INTERAÇÃO', route: '/home', disabled: false, hidden: false },
            { key: 'premiacao', label: 'LOJA', route: '/store', disabled: false, hidden: false },
            { key: 'beneficios', label: 'BENEFÍCIOS', route: '/benefits', disabled: false, hidden: false },
            { key: 'multipremios', label: 'MULTIPRÊMIOS', route: '/multi-awards', disabled: false, hidden: false },
            { key: 'desafios', label: 'DESAFIOS', route: '/challenges/list-of-challenges', disabled: false, hidden: false },
            { key: 'multipremios', label: 'MULTISORTE', route: '/multi-awards', disabled: false, hidden: false },
            { key: 'informacao', label: 'INFORMAÇÃO', route: '/information', disabled: false, hidden: false },
            { key: 'faq', label: 'FAQ', route: '/faq', disabled: false, hidden: false },
            { key: 'planos', label: 'PONTUAÇÃO', route: '/plans', disabled: false, hidden: false },
        ];

        setTimeout(async () => {
            this.menuHeader = await this.menuService.disableOrHiddenMenu(this.menuHeader);
        }, 500)

        await this.carregaSaldo();
        await this.carregaPtsExpirar();

        if (!this.modelLocator.dadosLogin.email) {
            this.consultaDados();
        }

    };

    async carregaSaldo() {
        try {
            let config = {
                "cpf": this.modelLocator.dadosLogin.cpf
            };
            const extractTotal = await this.extractService.getExtractTotal(config);
            if (extractTotal['status'] == 200) {
                this.modelLocator.saldo = extractTotal['result'];
            } else {
                this.modelLocator.saldo = 0;
            }
        } catch {
            this.modelLocator.saldo = 0;
            return this.messageServive.showToast('Erro ao processar saldo.', 'warning', 'bottom', 5000, true);
        }

    };

    async carregaPtsExpirar() {
        try {
            let config = {
                "cpf": this.modelLocator.dadosLogin.cpf
            };
            const extractExpiring = await this.extractService.getExtractExpiring(config);
            if (extractExpiring['status'] == 200) {
                this.modelLocator.pts_expirar = extractExpiring['pts_expirar'];
            } else {
                this.modelLocator.pts_expirar = 0;
            }
        } catch (err) {
            this.modelLocator.pts_expirar = 0;
            this.messageServive.showToast('Erro ao processar pontos a expirar.', 'warning', 'bottom', 5000, true);
        }
    };

    async consultaDados() {

        try {
            const profile = await this.profileService.getUserProfile();
            if (profile['status'] == 200) {
                this.modelLocator.dadosLogin.email = profile['result'].email;
                this.modelLocator.dadosLogin.celular = profile['result'].celular;
                this.modelLocator.dadosLogin.sexo = profile['result'].sexo;
                this.modelLocator.dadosLogin.nascimento = profile['result'].nascimento;
            }

        } catch (error) {
            console.error('Erro ao consultar dados do usuário:', error);
        }
    }

    touchGoToRoute(rota: string) {
        this.router.navigate([rota]);
    };

    logout() {

        this.modelLocator.logado = false;
        localStorage.clear();
        this.modelLocator.urlretorno = '';
        this.router.navigate(['/login']);

    };

}
